import { fmtNum } from '@/features/ah/utils';
import type { PrijsfavorietenPayload } from '../report';

/** 04 — Gebruikersgedrag: informative-page opens, total and per page. */
export function BehaviourSection({ behaviour }: { behaviour: PrijsfavorietenPayload['behaviour'] }) {
  const max = Math.max(...behaviour.topPages.map((p) => p.value), 1);
  return (
    <section id="gebruikersgedrag" className="section">
      <div className="section-head">
        <div>
          <div className="eyebrow">04 — Gebruikersgedrag</div>
          <h2>Navigatie &amp; ondersteuning</h2>
        </div>
      </div>
      <div className="grid-1-2">
        <div className="card">
          <div className="card-head">
            <h3>Informatieve pagina&rsquo;s geopend</h3>
            <span className="meta">Totaal</span>
          </div>
          <div className="ah-stat-huge">{fmtNum(behaviour.infoPagesTotal)}</div>
        </div>
        <div className="card">
          <div className="card-head">
            <h3>Populairste pagina&rsquo;s</h3>
            <span className="meta">Verdeling</span>
          </div>
          <div className="hbar-list">
            {behaviour.topPages.map((p) => (
              <div className="hbar-row" key={p.name}>
                <span className="label">{p.name}</span>
                <div className="bar">
                  <div className="bar-fill" style={{ width: `${(p.value / max) * 100}%` }} />
                </div>
                <span className="v">{fmtNum(p.value)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
